import React from 'react';

import { Level1, Level2, Level3 } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Box, Typography } from '@lyearn/ui';

interface LevelProps {
  level: string;
  className?: string;
  levelValue?: TSFixMe;
}

const levelIcons: Record<string, any> = {
  beginner: <Level1 />,
  intermediate: <Level2 />,
  advanced: <Level3 />,
};

const Level = ({ level, levelValue, className }: LevelProps) => {
  if (!level || !levelValue) {
    return null;
  }

  return (
    <Box className={cn('flex flex-row items-center', className)}>
      <Box className="h-24 w-24 me-12">{levelIcons[levelValue!]}</Box>
      <Typography className="items-center" color="text-text-paragraph" variant="body-long-01">
        {level}
      </Typography>
    </Box>
  );
};

export default Level;
